import { render, staticRenderFns } from "./BatchesPagination.vue?vue&type=template&id=75f88410&"
import script from "./BatchesPagination.vue?vue&type=script&lang=js&"
export * from "./BatchesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f88410')) {
      api.createRecord('75f88410', component.options)
    } else {
      api.reload('75f88410', component.options)
    }
    module.hot.accept("./BatchesPagination.vue?vue&type=template&id=75f88410&", function () {
      api.rerender('75f88410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/BatchesPagination.vue"
export default component.exports